import React from 'react';
import { Zap, Flame } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  pack: 'solo' | 'combo';
  isVisible: boolean;
}
export function PurchaseNotification({
  name,
  city,
  pack,
  isVisible
}: PurchaseNotificationProps) {
  const packName = pack === 'solo' ? 'Maestro Eléctrico' : 'Combo Maestro + PLC';
  const Icon = pack === 'solo' ? Zap : Flame;
  return <div className={`fixed left-4 z-30 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'} 
      bottom-4`} data-id="element-22">
      <div className="bg-white rounded-xl p-4 flex items-center gap-3 border-2 border-green-500 shadow-xl max-w-sm" data-id="element-23">
        <div className="bg-green-500 p-2 rounded-full flex-shrink-0" data-id="element-24">
          <Icon className="w-6 h-6 text-white" data-id="element-25" />
        </div>
        <div data-id="element-26">
          <p className="text-sm font-bold text-gray-900" data-id="element-27">
            <span className="text-green-700" data-id="element-28">{name}</span> de{' '}
            <span className="text-green-700" data-id="element-29">{city}</span>
          </p>
          <p className="text-xs text-gray-700 font-medium" data-id="element-30">
            compró <span className="font-black" data-id="element-31">{packName}</span>
          </p>
          <p className="text-[10px] text-gray-500 mt-1" data-id="element-32">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}